(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-order"] && !Shopify.designMode) return;
  try {
    
  class CustomOrderProducts extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('[data-track]');
      this.viewport = this.querySelector('[data-viewport]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.dots = this.querySelector('[data-dots]');
      this.nav = this.querySelector('[data-nav]');
      this.page = 0;
      this.onPrev = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);
      this.observer = new ResizeObserver(() => this.render());
      this.observer.observe(this);
      this.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', () => this.render(), { once: true });
      });
      this.render();
    }

    disconnectedCallback() {
      this.ready = false;
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.observer?.disconnect();
    }

    perView() {
      return window.matchMedia('(min-width: 750px)').matches ? 2 : 1;
    }

    pageCount() {
      return Math.max(1, Math.ceil(this.slides.length / this.perView()));
    }

    move(direction) {
      const pages = this.pageCount();
      this.page = (this.page + direction + pages) % pages;
      this.render();
    }

    render() {
      if (!this.track || this.slides.length === 0) return;

      const perView = this.perView();
      const pages = this.pageCount();
      if (this.page >= pages) this.page = 0;

      const styles = getComputedStyle(this.track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const slideWidth = this.slides[0].getBoundingClientRect().width;
      const offset = this.page * perView * (slideWidth + gap);
      this.track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      this.nav?.toggleAttribute('hidden', pages < 2);

      const startIndex = this.page * perView;
      this.slides.forEach((slide) => {
        slide.style.height = 'auto';
      });

      let visibleHeight = 0;
      this.slides.forEach((slide, index) => {
        const visible = index >= startIndex && index < startIndex + perView;
        if (!visible) return;
        visibleHeight = Math.max(visibleHeight, slide.offsetHeight);
      });

      const nextHeight = visibleHeight > 0 ? `${Math.ceil(visibleHeight)}px` : '';
      if (this.viewport && nextHeight && this.viewport.style.height !== nextHeight) {
        this.viewport.style.height = nextHeight;
      }

      this.slides.forEach((slide, index) => {
        const visible = index >= startIndex && index < startIndex + perView;
        slide.style.height = visible && nextHeight ? nextHeight : 'auto';
        slide.toggleAttribute('inert', !visible);
        slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });

      if (!this.dots) return;

      if (this.dots.childElementCount !== pages) {
        this.dots.replaceChildren();
        const labelTemplate = this.dataset.pageLabel || 'Page __PAGE__';
        for (let index = 0; index < pages; index += 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'custom-order__dot';
          button.setAttribute('aria-label', labelTemplate.replace('__PAGE__', String(index + 1)));
          button.addEventListener('click', () => {
            this.page = index;
            this.render();
          });
          this.dots.append(button);
        }
      }

      Array.from(this.dots.children).forEach((button, index) => {
        const current = index === this.page;
        button.classList.toggle('is-active', current);
        if (current) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('custom-order-products')) {
    customElements.define('custom-order-products', CustomOrderProducts);
  }

  const sizeChoiceInputs = (root) => {
    root.querySelectorAll('.radio-wrapper, .checkbox-wrapper, .globo-list-control').forEach((item) => {
      item.style.setProperty('margin', '0', 'important');
      item.style.setProperty('padding', '0', 'important');
    });
    root.querySelectorAll('.radio-input, .checkbox-input').forEach((input) => {
      input.style.setProperty('position', 'absolute', 'important');
      input.style.setProperty('inset-block-start', '0.05rem', 'important');
      input.style.setProperty('inset-inline-start', '0', 'important');
      input.style.setProperty('z-index', '2', 'important');
      input.style.setProperty('width', '1.125rem', 'important');
      input.style.setProperty('height', '1.125rem', 'important');
      input.style.setProperty('min-width', '1.125rem', 'important');
      input.style.setProperty('min-height', '1.125rem', 'important');
      input.style.setProperty('margin', '0', 'important');
      input.style.setProperty('opacity', '0', 'important');
      input.style.setProperty('cursor', 'pointer', 'important');
      input.style.setProperty('pointer-events', 'auto', 'important');
    });
  };

  const stackFormRows = (root) => {
    const stacked = window.matchMedia('(max-width: 749px)').matches;
    root.querySelectorAll('.globo-form-row').forEach((row) => {
      row.style.setProperty('display', 'flex', 'important');
      row.style.setProperty('flex-direction', stacked ? 'column' : 'row', 'important');
      row.style.setProperty('flex-wrap', 'nowrap', 'important');
      row.style.setProperty('grid-template-columns', stacked ? '1fr' : 'repeat(2, minmax(0, 1fr))', 'important');
    });
    root.querySelectorAll('.globo-form-row-item').forEach((item) => {
      item.style.setProperty('width', stacked ? '100%' : 'auto', 'important');
      item.style.setProperty('max-width', stacked ? '100%' : 'none', 'important');
      item.style.setProperty('min-width', '0', 'important');
      item.style.setProperty('flex', stacked ? '1 1 100%' : '1 1 0', 'important');
    });
  };

  const watchChoiceInputs = () => {
    document.querySelectorAll('.custom-order__form').forEach((form) => {
      sizeChoiceInputs(form);
      stackFormRows(form);
      if (form.dataset.choiceBound === 'true') return;
      form.dataset.choiceBound = 'true';
      new MutationObserver(() => {
        sizeChoiceInputs(form);
        stackFormRows(form);
      }).observe(form, { childList: true, subtree: true });
    });
  };

  watchChoiceInputs();
  if (!window.customOrderFormBound) {
    window.customOrderFormBound = true;
    window.addEventListener('resize', watchChoiceInputs);
    document.addEventListener('shopify:section:load', watchChoiceInputs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
